/**
 * Display-only JWT payload decoding for the Identity view: the browser shows what the access
 * token *claims*, unverified — the server-validated truth comes from GET /api/me, which is the
 * whole point of showing the two side by side.
 */
export function decodeClaims(token: string): Record<string, unknown> | null {
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  const segment = parts[1]!.replace(/-/g, '+').replace(/_/g, '/');
  try {
    const payload = JSON.parse(
      atob(segment.padEnd(segment.length + ((4 - (segment.length % 4)) % 4), '=')),
    ) as unknown;
    return typeof payload === 'object' && payload !== null && !Array.isArray(payload)
      ? (payload as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}
